<template>
  <b-form-group
    label="Telefone"
    label-for="phone"
    description="Digite o telefone no formato (XX) XXXXX-XXXX"
  >
    <b-form-input
      id="phone"
      v-model="formattedPhone"
      type="text"
      placeholder="(XX) XXXXX-XXXX"
      required
      :state="phoneState"
      aria-describedby="phone-feedback"
      @blur="validatePhone"
    ></b-form-input>
    <b-form-invalid-feedback id="phone-feedback">
      Por favor, insira um telefone válido com o código do estado e 9 números.
    </b-form-invalid-feedback>
  </b-form-group>
</template>

<script>
export default {
  name: 'PhoneInput',
  props: {
    value: {
      type: String,
      required: true,
    },
    state: {
      type: Boolean,
      default: null,
    },
  },
  data() {
    return {
      phoneState: this.state,
    };
  },
  computed: {
    formattedPhone: {
      get() {
        return this.formatPhone(this.value);
      },
      set(newValue) {
        this.$emit('input', this.cleanPhone(newValue));
      },
    },
  },
  watch: {
    state(newValue) {
      this.phoneState = newValue;
    },
  },
  mounted() {
    if (this.value) {
      this.validatePhone();
    }
  },
  methods: {
    formatPhone(value) {
      if (!value) return '';
      const cleaned = value.replace(/\D/g, '');
      const match = cleaned.match(/^(\d{2})(\d{5})(\d{4})$/);
      return match ? `(${match[1]}) ${match[2]}-${match[3]}` : value;
    },
    cleanPhone(value) {
      return value.replace(/\D/g, '');
    },
    validatePhone() {
      const phoneRegex = /^\d{11}$/;
      this.phoneState = phoneRegex.test(this.cleanPhone(this.value));
      this.$emit('validation-updated', this.phoneState);
    },
  },
};
</script>
